{
  "newCampaign": "New campaign",
  "firmware": {
    "update": {
      "label": "Update firmware",
      "description": "Date and time parameters are required to launch the update of the {name} firmware",
      "firmwareLabel": "Firmware",
      "uuidRequired": "The firmware is required",
      "plannedStartAt": "Datetime of firmware update (YYYY/MM/DD HH:MM)",
      "notaBene": "The update of the firwmare will be carried out during the next communication with the {name} from the update date time of the firmware.",
      "dateTimeError": "A datetime is required for updating firmware",
      "firmwareSelection": "Select a firmware in the list below",
      "FirmwareSelectionRequired": "You must select a firmware from the list",
      "warningMessage": "Warning: Updating the firmware will induce a reboot of the related devices at the end of the update."
    }
  },
  "dateInferiorToToday": "The date must not be smaller than today's date/time",
  "dateInferiorToDate": "The date must not be smaller than {date}",
  "dateFormat": "YYYY-MM-DD HH:mm",
  "confirm": "Confirm",
  "cancel": "Cancel",
  "list": {
    "column": {
      "name": {
        "label": "Campaign"
      },
      "type": {
        "label": "Type",
        "CRTCLT_RENEWAL_DVC": "Devices certificates renewal",
        "CRTCLT_RENEWAL_APP": "Applications certificates renewal",
        "FIRMWARE_UPGRADE_DVC": "Devices firmware update"
      },
      "dates": {
        "label": "Dates",
        "format": "YYYY-MM-DD"
      },
      "numberOfEquipments": {
        "label": "Numbers of equipment",
        "value": "{count} equipments | {count} equipment | {count} equipments"
      },
      "status": {
        "label": "Status",
        "value": {
          "SCHEDULED": "Scheduled",
          "RUNNING": "Running",
          "PAUSED": "Paused",
          "COMPLETE": "Complete",
          "COMPLETE_WITH_ERRORS": "Complete with errors",
          "INCOMPLETE": "Incomplete",
          "PLATFORM_ERROR": "Error",
          "CANCELLING": "Cancelling",
          "CANCELLED": "Cancelled",
          "UNKNOWN": "Unknown",
          "DRAFT": "Draft"
        }
      },
      "pending": {
        "label": "Pending"
      },
      "inProgress": {
        "label": "In progress"
      },
      "success": {
        "label": "Success"
      },
      "failed": {
        "label": "Failed"
      },
      "numberOfDevice": {
        "label": "Number of devices",
        "value": "{count} devices | {count} device | {count} devices"
      },
      "operations": "Operations",
      "done": {
        "label": "Done"
      }
    },
    "empty": "No campaigns found"
  },
  "details": {
    "buttons": {
      "update": {
        "label": "Update"
      },
      "cancel": {
        "label": "Cancel the campaign",
        "confirm": {
          "message": "Confirm cancel campaign?",
          "title": "Cancel campaign",
          "yes": "Yes",
          "no": "No"
        }
      },
      "edit": {
        "label": "Edit"
      }
    },
    "properties": {
      "title": "Properties",
      "name": {
        "label": "Name"
      },
      "type": {
        "label": "Type",
        "CRTCLT_RENEWAL_DVC": "Devices certificates renewal",
        "CRTCLT_RENEWAL_APP": "Applications certificates renewal",
        "FIRMWARE_UPGRADE_DVC": "Devices firmware update"
      },
      "dates": {
        "label": "Dates"
      },
      "state": {
        "label": "Status"
      }
    },
    "characteristics": {
      "title": "Characteristics",
      "createdBy": "Created by",
      "type": {
        "label": "Type:",
        "value": {
          "CRTCLT_RENEWAL_DVC": "Devices certificates renewal",
          "CRTCLT_RENEWAL_APP": "Applications certificates renewal",
          "FIRMWARE_UPGRADE_DVC": "Devices firmware update"
        }
      },
      "status": {
        "label": "Status:",
        "value": {
          "SCHEDULED": "Scheduled",
          "RUNNING": "Running",
          "PAUSED": "Paused",
          "COMPLETE": "Complete",
          "COMPLETE_WITH_ERRORS": "Failed",
          "INCOMPLETE": "Failed",
          "PLATFORM_ERROR": "Error",
          "CANCELLING": "Cancelling",
          "CANCELLED": "Cancelled"
        }
      },
      "lifeCyle": {
        "creation": "Creation: {value}",
        "launch": "Launch: {value}",
        "closing": "Closing: {value}"
      },
      "inclusionPeriods": {
        "title": "Inclusion periods",
        "inactive": "inactive",
        "monday": "Monday: {value}",
        "tuesday": "Tuesday: {value}",
        "wednesday": "Wednesday: {value}",
        "thursday": "Thursday: {value}",
        "friday": "Friday: {value}",
        "saturday": "Saturday: {value}",
        "sunday": "Sunday: {value}"
      },
      "equipments": {
        "title": "{count} equipments | {count} equipment | {count} equipments",
        "status": {
          "pending": "Pending: {percent}, {count} equipments | Pending: {percent}, {count} equipment | Pending: {percent}, {count} equipments",
          "running": "Running: {percent}, {count} equipments | Running: {percent}, {count} equipment | Running: {percent}, {count} equipments",
          "complete": "Complete: {percent}, {count} equipments | Complete: {percent}, {count} equipment | Complete: {percent}, {count} equipments",
          "failed": "Failed: {percent}, {count} equipments | Failed: {percent}, {count} equipment | Failed: {percent}, {count} equipments"
        },
        "statistics": {
          "title": "{count} devices | {count} device | {count} devices"
        }
      },
      "devices": {
        "status": {
          "scheduled": "Scheduled: {percent}, {count} devices | Scheduled: {percent}, {count} device | Scheduled: {percent}, {count} devices",
          "completed": "Completed: {percent}, {count} devices | Completed: {percent}, {count} device | Completed: {percent}, {count} devices",
          "error": "Error: {percent}, {count} devices | Error: {percent}, {count} device | Error: {percent}, {count} devices",
          "running": "Running: {percent}, {count} devices | Running: {percent}, {count} device | Running: {percent}, {count} devices"
        }
      },
      "operationType": "Type:"
    },
    "equipments": {
      "title": "Device list",
      "column": {
        "label": {
          "label": "Device name"
        },
        "deviceType": {
          "label": "Device type"
        },
        "message": {
          "label": "Operation state"
        },
        "startDate": {
          "label": "Operation start date",
          "format": "YYYY-MM-DD HH:mm"
        },
        "lastOperationDate": {
          "label": "Last operation date",
          "format": "YYYY-MM-DD HH:mm"
        },
        "name": {
          "label": "Name"
        },
        "serialNumber": {
          "label": "Serial number"
        },
        "firmware": {
          "label": "Firmware"
        },
        "connectivity": {
          "label": "Connectivity"
        },
        "metastatus": {
          "label": "Metastatus"
        },
        "sector": {
          "label": "Sector"
        },
        "lastUpdate": {
          "label": "Last updated date"
        },
        "operationStatus": {
          "label": "Operation status"
        }
      },
      "empty": "No equipments found",
      "states": {
        "WITHDRAWN": "Withdrawn",
        "DEACTIVATED": "Deactivated",
        "DELETED": "Deleted"
      }
    },
    "status": {
      "title": "Campaign status"
    },
    "cancel": {
      "error": "An error occurred during the campaign cancellation.",
      "success": "The campaign cancellation has been successfully triggered."
    }
  },
  "form": {
    "campaignSettings": {
      "title": "Campaign settings",
      "name": "Campaign name",
      "typeOfCampaign": {
        "title": "Type of campaign",
        "firmwareUpdate": {
          "title": "Firmware update campaign",
          "option": "Devices firmware update",
          "label": "Firmware name",
          "dependencies": "Dependencies"
        },
        "deviceCertificateRenewal": "Devices certificates renewal",
        "applicationCertificateRenewal": "Applications certificates renewal"
      },
      "validation": {
        "name": "The campaign name is required",
        "type": "The campaign type is required",
        "firmwareUuid": "The firmware is required"
      }
    },
    "fleetSelection": {
      "title": "Equipment fleet selection",
      "devices": "Devices",
      "applications": "Applications",
      "validation": {
        "required": "Selecting at least one equipment is required"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Existing scheduled actions",
            "message": "Some selected equipments already have scheduled actions. Continue?",
            "yes": "Yes",
            "no": "No"
          }
        }
      }
    },
    "campaignPlanification": {
      "title": "Campaign planification",
      "executionDates": {
        "title": "Campaign execution dates",
        "plannedStartAt": "Campaign launch date",
        "endDate": "Campaign end date",
        "validation": {
          "plannedStartAt": "The campaign launch date is required",
          "plannedEndAt": "The campaign end date is required",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "The campaign launch date cannot be after license expiration date tolerancy",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "The campaign end date cannot be after license expiration date tolerancy"
        }
      },
      "inclusionPeriods": {
        "title": "Inclusion periods",
        "remove": "Remove",
        "add": "Add",
        "day": "Day",
        "days": {
          "monday": "monday",
          "tuesday": "tuesday",
          "wednesday": "wednesday",
          "thursday": "thursday",
          "friday": "friday",
          "saturday": "saturday",
          "sunday": "sunday"
        },
        "validation": {
          "day": "The inclusion period day is required",
          "range": "The span time of an inclusion period slot cannot be less than 15 minutes"
        }
      }
    },
    "buttons": {
      "next": "Next",
      "previous": "Previous",
      "submit": "Submit"
    }
  },
  "report": {
    "title": "Report",
    "plannedStartAt": "Campaign launch date:",
    "processes": {
      "column": {
        "label": "Name",
        "status": "Status"
      }
    }
  },
  "funnel": {
    "step": "Step",
    "of": "of",
    "newCampaign": "Setting a new campaign",
    "updateCampaign": "Update the campaign",
    "scheduling": "Scheduling",
    "next": "Next",
    "previous": "Previous",
    "publish": "Publish the campaign",
    "campaignSettings": {
      "title": "Choose the settings",
      "name": "Campaign name",
      "typeOfCampaign": {
        "title": "Type of campaign",
        "firmwareUpdate": {
          "label": "Firmware update",
          "title": "Firmware update campaign",
          "firmwareName": "Firmware name"
        },
        "certificate": "Certificate",
        "deviceCertificateRenewal": "Devices certificates renewal",
        "applicationCertificateRenewal": "Applications certificates renewal",
        "configurationUpdate": {
          "selfSupporting": {
            "warningMessage": "This campaign will apply the most recently uploaded configuration to each of your selected devices."
          }
        }
      },
      "validation": {
        "name": "The campaign name is required",
        "type": "The campaign type is required",
        "firmwareUuid": "The firmware is required"
      },
      "operationModelType": {
        "CONFIG": "Configuration",
        "FIRM_UPDATE": "Firmware update",
        "OPTIONS": "Options",
        "CERT_RENEW": "Certificate renewal"
      }
    },
    "fleetSelection": {
      "title": "Equipment fleet",
      "validation": {
        "required": "Selecting at least one equipment is required"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Existing scheduled actions",
            "message": "Some selected equipments already have scheduled actions. Continue?",
            "yes": "Yes",
            "no": "No"
          }
        }
      },
      "devices": "Devices",
      "fleets": "Fleets",
      "fleetInformation": {
        "title": "{fleetName} information",
        "message": {
          "beginning": "With the current campaign configuration,",
          "middle": "{count} device in the fleet | {count} device in the fleet  | {count} devices in the fleet",
          "end": "cannot be updated | cannot be updated | will not be able to be updated"
        }
      }
    },
    "campaignPlanification": {
      "title": "Choose the date",
      "executionDates": {
        "plannedStartAt": "Campaign launch date",
        "endDate": "Campaign end date",
        "validation": {
          "plannedStartAt": "The campaign launch date is required",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "The campaign launch date cannot be later than the license expiration date tolerancy",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "The campaign end date cannot be later than the license expiration date tolerancy",
          "plannedEndAt": "The campaign end date is required"
        }
      },
      "inclusionPeriods": {
        "title": "Inclusion period",
        "subTitle": "Optional",
        "informations": {
          "period": "This is a period during which the device is allowed to execute the action.",
          "defaultValue": "By default no restriction will be applied to the device.",
          "businessHour": "Business hour (Monday to Friday - 9am to 6pm)",
          "weekendHour": "Weekend (Saturday to Sunday - 12am to 11:59pm)"
        },
        "days": {
          "monday": "Monday",
          "tuesday": "Tuesday",
          "wednesday": "Wednesday",
          "thursday": "Thursday",
          "friday": "Friday",
          "saturday": "Saturday",
          "sunday": "Sunday"
        },
        "addADay": "Add a day",
        "add": "Add",
        "delete": "Delete",
        "selectPlaceholder": "Select a day",
        "start": "Start",
        "end": "End",
        "validation": {
          "day": "The inclusion period day is required",
          "start": "The inclusion period start is required",
          "end": "The inclusion period end is required",
          "range": "The span time of an inclusion period slot cannot be less than 15 minutes",
          "startAfterEnd": "Start time cannot be later than end time",
          "endBeforeStart": "End time cannot be earlier than start time"
        },
        "presets": {
          "businessHours": "Business hour (monday to friday - 9am to 6pm)",
          "weekend": "Weekend (saturday to sunday - 12am to 11:59pm)"
        }
      }
    },
    "deviceFleetSelection": {
      "title": "Device fleet"
    }
  },
  "operationModelType": {
    "composite": "Composite"
  },
  "operationMgr": {
    "filters": {
      "status": "Status",
      "type": "Type"
    }
  }
}
